import React from 'react'
import styled from 'styled-components'

import Navbar from '../../defaultComponents/Navbar'
import Footer from '../../defaultComponents/Footer'

const PageWrapper = styled.div`

`

const DashboardContainer = styled.div`
  height: 100vh;

  display: flex;

  gap: 20px;

  padding: 40px;

  background: #111111;

  color: #f8f8f8;
  font-weight: bold;
`

const Section = styled.div`
  width: 20vw;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const SectionCenter = styled.div`
  flex-grow: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
/* 
  border-left: 1px solid #444444;
  border-right: 1px solid #444444; */

  gap: 50px;
`

const SectionCenterTitle = styled.div`
  font-size: 4rem;
`

const TargetBox = styled.div`
  display: flex;
  align-items: center;

  flex-direction: column;

  text-align: center;

  gap: 50px;

  /* border: 1px solid white; */

  &.CENTER {
    border: 1px solid darkgrey;
    padding: 40px 0px 40px 0px;
    border-radius: 10px;
  }

  width: 90%;
`

const TargetWrapperBox = styled.div`
  display: flex;
  gap: 100px;

  > div {
    width: 300px;
  }
`

const TargetWrapper = styled.div`
  font-size: 40px;

  &.HIGHLIGHT {
    border: 2px solid #333333;
    border-radius: 20px;
    padding: 10px 50px 10px 50px;
  }
`

const TargetTitle = styled.div`
  line-height: 40px;  
`

const TargetValue = styled.div`
  color: #1cbed2;
  font-weight: bold;

  font-size: 100px;
  line-height: 100px;

  &.OVER {
    color: #63d21c;
  }

  &.CURRENT {
    color: #444444;
  }

  &.UNDER {
    color: #d2311c;
  }
`

export default function AllroadDashboardPage() {

  const [todayData, setTodayData] = React.useState({ uniqueWorkers: 0, totalHours: 0 })
  const [yesterdayData, setYesterdayData] = React.useState({ uniqueWorkers: 0, totalHours: 0 })
  const [weekData, setWeekData] = React.useState({ uniqueWorkers: 0, totalHours: 0 })

  const [progress, setProgress] = React.useState(0)
  const [change, setChange] = React.useState(0)

  const [pendingToday, setPendingToday] = React.useState(0);
  const [pendingYesterday, setPendingYesterday] = React.useState(0)

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);
  const[fullscreen, setFullscreen] = React.useState(false)

  const formatDate = (date) => {
    let month = '' + (date.getMonth() + 1),
      day = '' + date.getDate(),
      year = date.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  const getAllDates = async () => {
    // Get today's date
    const today = new Date();
    const todayFormatted = formatDate(today);

    // Get yesterday's date
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayFormatted = formatDate(yesterday);

    // Get the start of the week (Sunday)
    const weekStart = new Date(today);
    weekStart.setDate(weekStart.getDate() - weekStart.getDay());
    const weekStartFormatted = formatDate(weekStart);

    // Get the end of the week (Saturday)
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + 6);
    const weekEndFormatted = formatDate(weekEnd);

    return {
      today: todayFormatted,
      yesterday: yesterdayFormatted,
      weekStart: weekStartFormatted,
      weekEnd: weekEndFormatted
    };
  }

  const getTimesheetsProvider = async () => {

    const dates = await getAllDates()
    const today = await getTimesheets(dates.today, dates.today)
    const yesterday = await getTimesheets(dates.yesterday, dates.yesterday)
    const week = await getTimesheets(dates.weekStart, dates.weekEnd)
    setTodayData(today);
    setYesterdayData(yesterday);
    setWeekData(week);

    const myProgress = parseInt((week.totalHours / 2000) * 100)
    setProgress(myProgress)

    const myChange = parseInt(today.totalHours - yesterday.totalHours)
    setChange(myChange)
  }

  const getTimesheets = async (startDate, endDate) => {

    try {
      const res = await fetch(`/api/Assignar/timesheets/${startDate}/${endDate}`)

      const data = await res.json();

      return data
    } catch (error) {
      console.error(error)
    }
  }

  const getPendingAllocationsProvider = async () => {
    const dates = await getAllDates()
    const today = await getPendingAllocations(dates.today, dates.today)
    const yesterday = await getPendingAllocations(dates.yesterday, dates.yesterday)

    setPendingToday(today)
    setPendingYesterday(yesterday)
  }

  const getPendingAllocations = async (targetDate) => {
    try {
      const res = await fetch(`/api/Assignar/allocations/hours/${targetDate}`)

      const data = await res.json()

      if (data.error) {
        throw new Error("Error getting Timesheets")
      }

      return data.hours
    } catch (error) {
      console.error(error)
    }
  }

  React.useEffect(() => {
    // Function to handle the resize event
    function handleResize() {
      // Update state or perform actions when window is resized
      setWindowHeight(window.innerHeight);
      
      if (window.innerHeight === window.screen.height) {
        setFullscreen(true)
      } else {
        setFullscreen(false)
      }
    }

    // Add the event listener
    window.addEventListener('resize', handleResize);

    // Clean-up function
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  React.useEffect(()=> {
    getPendingAllocationsProvider()
    getTimesheetsProvider()
  },[])

  return (
    <>
    
      {fullscreen === false && <Navbar pageType="Dashboard" />}      
      <PageWrapper>
        <DashboardContainer>
          <Section>
            <TargetBox>
              <TargetWrapper className={"HIGHLIGHT"}>
                <TargetTitle>
                  YESTERDAY COMPLETE
                </TargetTitle>
                <TargetValue className={"UNDER"}>
                  {parseInt(yesterdayData.totalHours)}
                </TargetValue>
              </TargetWrapper>
              <TargetWrapper className={"HIGHLIGHT"}>
                <TargetTitle>
                  YESTERDAY PENDING
                </TargetTitle>
                <TargetValue className={"UNDER"}>
                  {parseInt(pendingYesterday)}
                </TargetValue>
              </TargetWrapper>
              <TargetWrapper className={"HIGHLIGHT"}>
                <TargetTitle>
                  CHANGE
                </TargetTitle>
                <TargetValue className={change >= 0 ? "OVER" : "UNDER"}>
                  {change}
                </TargetValue>
              </TargetWrapper>
            </TargetBox>
          </Section>
          <SectionCenter>

            <SectionCenterTitle>
            {new Date().toLocaleDateString('en-us', { weekday:"long", month:"short", day:"numeric"})}
            </SectionCenterTitle>
            <TargetBox className="CENTER">

              <TargetWrapperBox>
                <TargetWrapper>
                  <TargetTitle>
                    COMPLETE
                  </TargetTitle>
                  <TargetValue className={"UNDER"}>
                    {parseInt(todayData.totalHours)}
                  </TargetValue>
                </TargetWrapper>
                <TargetWrapper>
                  <TargetTitle>
                    PENDING
                  </TargetTitle>
                  <TargetValue className={"OVER"}>
                    {parseInt(pendingToday)}
                  </TargetValue>
                </TargetWrapper>
              </TargetWrapperBox>

            </TargetBox>
            <TargetBox>
              <TargetWrapper className="HIGHLIGHT">
                <TargetTitle>
                  TARGET
                </TargetTitle>
                <TargetValue>
                  400
                </TargetValue>
              </TargetWrapper>
            </TargetBox>
          </SectionCenter>
          <Section>
            <TargetBox>
              <TargetWrapper className={"HIGHLIGHT"}>
                <TargetTitle>
                  WEEK PROGRESS
                </TargetTitle>
                <TargetValue className={progress >= 50 ? "OVER" : "UNDER"}>
                  {progress}%
                </TargetValue>
              </TargetWrapper>
              <TargetWrapper className={"HIGHLIGHT"}>
                <TargetTitle >
                  WEEK TOTAL
                </TargetTitle>
                <TargetValue className={"OVER"}>
                  {parseInt(weekData.totalHours)}
                </TargetValue>
              </TargetWrapper>
              <TargetWrapper className={"HIGHLIGHT"}>
                <TargetTitle>
                  WEEK TARGET
                </TargetTitle>
                <TargetValue >
                  2000
                </TargetValue>
              </TargetWrapper>
            </TargetBox>
          </Section>
        </DashboardContainer>
        {fullscreen === false && <Footer />}     
      </PageWrapper>
    </>
  )
}
